import { Image, Polygon, Svg } from "@react-pdf/renderer";
import { azureSASTokenToUrl } from "../../formatted/FormattedAzureSasToken";
import { formattedColorMaterial } from "../../formatted/FormattedText";

const adjustDimensions = ({ x_box, y_box, w_box, h_box, imageDimensions }) => {
  const adjustedXBox = Math.max(0, x_box);
  const adjustedYBox = Math.max(0, y_box);
  const adjustedWidth = Math.min(
    w_box + Math.min(0, x_box),
    imageDimensions.width - adjustedXBox,
  );
  const adjustedHeight = Math.min(
    h_box + Math.min(0, y_box),
    imageDimensions.height - adjustedYBox,
  );

  return { adjustedXBox, adjustedYBox, adjustedWidth, adjustedHeight };
};

export const ImageComponent = ({
  data,
  drawMaterial,
  height,
  width,
  backgroundColor = "#FFF",
  materialFillOpacity = 0.5,
  materialStrokeWidth = 1,
}) => {
  const { adjustedXBox, adjustedYBox, adjustedWidth, adjustedHeight } =
    adjustDimensions(data);
  const outlineOnly = materialFillOpacity <= 0;
  return (
    <Svg
      viewBox={`${adjustedXBox} ${adjustedYBox} ${adjustedWidth} ${adjustedHeight}`}
      style={{
        marginTop: "5px",
        height: height ? height : "800px",
        width: width || "auto",
        backgroundColor,
      }}
    >
      <Image
        x={0}
        y={0}
        width={data.imageDimensions.width}
        height={data.imageDimensions.height}
        href={
          data?.compressedImage
            ? data.compressedImage
            : azureSASTokenToUrl(data.image_url)
        }
      />
      {data.wasteObjectsList?.length > 0 &&
        data.wasteObjectsList.map(
          (object, index) =>
            drawMaterial &&
            object.cls &&
            Array.isArray(object.points_konva) &&
            object.points_konva.length > 1 && (
              <Polygon
                key={`${object.cls}-${index}`}
                points={object.points_konva.join(",")}
                fill={outlineOnly ? "none" : formattedColorMaterial(object.cls)}
                fillOpacity={outlineOnly ? 0 : materialFillOpacity}
                stroke={formattedColorMaterial(object.cls)}
                strokeOpacity={1}
                strokeWidth={materialStrokeWidth}
              />
            ),
        )}
    </Svg>
  );
};
